export default __webpack_public_path__ + "static/media/logo.336dd7f1.png";